/*
 * A version constant that can be used within components.
 */
export const VERSION = '20261103-102949-07db2c2';
